import { render, staticRenderFns } from "./CreateOffers.vue?vue&type=template&id=81939808"
import script from "./CreateOffers.vue?vue&type=script&lang=js"
export * from "./CreateOffers.vue?vue&type=script&lang=js"
import style0 from "./CreateOffers.vue?vue&type=style&index=0&id=81939808&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports